var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstudiante2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 94,
    viewBox: "0 0 57 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.60001 73.57L19.72 62.94V32.56L1.60001 43.19V73.57Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.389999 44.29L1.6 44.98V73.57L0.389999 72.98V44.29Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.58 71.04L39.54 61.18V41.91L22.58 51.77V71.04Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 54.5V51.7H22.58V53.62L39.65 63.48L56.61 53.62",
    fill: "#EAEAEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 54.5V51.7H22.58V53.62L39.65 63.48L56.61 53.62",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.65 82.75L56.61 72.89V53.62L39.65 63.48V82.75Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 51.7L39.54 41.84L22.58 51.7L39.65 61.56L56.61 51.7Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.54 46.69C49.7074 45.5427 50.7163 44.2445 51.54 42.83C52.86 41.41 52.97 34.61 51.67 30.15C50.37 25.69 50.17 22.3 39.37 19.23L39.71 19.93C35.35 18.2 31.06 19.1 31.06 22.93C31.1213 27.1181 30.7426 31.301 29.93 35.41L21.43 40.93L24.8 42.8C24.8 42.8 30.7 41.09 33.53 38.8C33.12 40.14 32.34 42.16 31.71 44.09C19.58 50.21 17.93 53.3 20.71 73.31L24.43 75.38C25.43 65.32 25.56 61.52 29.8 57.82C28.5 62.67 28.93 68.92 29.8 78.29L33.52 80.36C37.52 64.3 37.86 62.36 42.82 58.75C46.51 56.07 49.05 53.64 48.64 49.1C48.61 48.21 48.58 47.42 48.54 46.69Z",
    fill: "#252525",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8 78.27C21.8 82.27 25.94 87.97 33.52 80.34L29.8 78.27Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M47.57 50.38C46.45 58.38 50.96 55.52 50.21 50.72L47.57 50.38Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 53.34V50.78L0.389999 42.53V44.29L33.18 63.16L51.3 52.54",
    fill: "#DEDEDE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 53.34V50.78L0.389999 42.53V44.29L33.18 63.16L51.3 52.54",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.18 93.54L51.3 82.92V52.54L33.18 63.16V93.54Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 50.78L18.52 31.91L0.389999 42.53L33.18 61.41L51.3 50.78Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.18 93.54L31.98 92.94V62.56L33.18 63.16V93.54Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.46 42.23L14.6 47.89L29.4 52.18L36.25 46.52L21.46 42.23Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.93 49.16L30.29 56.56L21.68 51.61L34.31 44.21L42.93 49.16Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 73.29C11.68 78.04 17.42 81.59 24.47 75.36L20.75 73.29Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.53 49.61C35.36 52.39 37.37 56 42.47 51.61L39.53 49.61Z",
    fill: "#5E534F",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.22 14.05C35.0484 14.05 35.72 13.3784 35.72 12.55C35.72 11.7216 35.0484 11.05 34.22 11.05C33.3916 11.05 32.72 11.7216 32.72 12.55C32.72 13.3784 33.3916 14.05 34.22 14.05Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.52 13.16C36.8123 13.16 37.86 12.1123 37.86 10.82C37.86 9.52765 36.8123 8.48 35.52 8.48C34.2276 8.48 33.18 9.52765 33.18 10.82C33.18 12.1123 34.2276 13.16 35.52 13.16Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.71 11.52C36.3727 11.52 36.91 10.9827 36.91 10.32C36.91 9.65725 36.3727 9.12 35.71 9.12C35.0473 9.12 34.51 9.65725 34.51 10.32C34.51 10.9827 35.0473 11.52 35.71 11.52Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M35.14 9.79C35.7089 9.79 36.17 9.32885 36.17 8.76C36.17 8.19114 35.7089 7.73 35.14 7.73C34.5711 7.73 34.11 8.19114 34.11 8.76C34.11 9.32885 34.5711 9.79 35.14 9.79Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M36.54 8.76001C36.9984 8.76001 37.37 8.3884 37.37 7.93001C37.37 7.47161 36.9984 7.10001 36.54 7.10001C36.0816 7.10001 35.71 7.47161 35.71 7.93001C35.71 8.3884 36.0816 8.76001 36.54 8.76001Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.57 18.48C33.5854 18.9533 33.6947 19.4188 33.8918 19.8494C34.0888 20.28 34.3695 20.6671 34.7175 20.9882C35.0656 21.3093 35.4741 21.5579 35.9191 21.7196C36.3642 21.8813 36.837 21.9528 37.31 21.93C37.3901 22.269 37.4903 22.6029 37.61 22.93C38.06 24.02 44.19 23.09 43.67 20.53C43.09 17.68 46.13 15.37 43.91 11.82C40.22 6.00001 34.67 8.60001 33.75 13.61C33.4988 15.2206 33.4384 16.8552 33.57 18.48Z",
    fill: "#5E534F",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M36.62 9.73999C37.0894 9.73999 37.47 9.35944 37.47 8.88999C37.47 8.42055 37.0894 8.03999 36.62 8.03999C36.1506 8.03999 35.77 8.42055 35.77 8.88999C35.77 9.35944 36.1506 9.73999 36.62 9.73999Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M38.47 10.81C39.0996 10.81 39.61 10.2996 39.61 9.67C39.61 9.04039 39.0996 8.53 38.47 8.53C37.8404 8.53 37.33 9.04039 37.33 9.67C37.33 10.2996 37.8404 10.81 38.47 10.81Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M40.54 13.16C41.2304 13.16 41.79 12.6004 41.79 11.91C41.79 11.2196 41.2304 10.66 40.54 10.66C39.8497 10.66 39.29 11.2196 39.29 11.91C39.29 12.6004 39.8497 13.16 40.54 13.16Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M40.13 10.96C40.5553 10.96 40.9 10.6153 40.9 10.19C40.9 9.76474 40.5553 9.42 40.13 9.42C39.7047 9.42 39.36 9.76474 39.36 10.19C39.36 10.6153 39.7047 10.96 40.13 10.96Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M42.55 12.91C43.4889 12.91 44.25 12.1489 44.25 11.21C44.25 10.2711 43.4889 9.50999 42.55 9.50999C41.6111 9.50999 40.85 10.2711 40.85 11.21C40.85 12.1489 41.6111 12.91 42.55 12.91Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M41.05 15.9C41.9778 15.9 42.73 15.1478 42.73 14.22C42.73 13.2922 41.9778 12.54 41.05 12.54C40.1222 12.54 39.37 13.2922 39.37 14.22C39.37 15.1478 40.1222 15.9 41.05 15.9Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M42.55 17.12C43.4834 17.12 44.24 16.3634 44.24 15.43C44.24 14.4966 43.4834 13.74 42.55 13.74C41.6166 13.74 40.86 14.4966 40.86 15.43C40.86 16.3634 41.6166 17.12 42.55 17.12Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M43.65 18.76C44.1636 18.76 44.58 18.3436 44.58 17.83C44.58 17.3164 44.1636 16.9 43.65 16.9C43.1364 16.9 42.72 17.3164 42.72 17.83C42.72 18.3436 43.1364 18.76 43.65 18.76Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M44.73 15.83C45.6026 15.83 46.31 15.1226 46.31 14.25C46.31 13.3774 45.6026 12.67 44.73 12.67C43.8574 12.67 43.15 13.3774 43.15 14.25C43.15 15.1226 43.8574 15.83 44.73 15.83Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M42.55 10.12C43.5331 10.12 44.33 9.32306 44.33 8.34C44.33 7.35693 43.5331 6.56 42.55 6.56C41.5669 6.56 40.77 7.35693 40.77 8.34C40.77 9.32306 41.5669 10.12 42.55 10.12Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M40.34 9.25999C41.1684 9.25999 41.84 8.58842 41.84 7.75999C41.84 6.93157 41.1684 6.25999 40.34 6.25999C39.5116 6.25999 38.84 6.93157 38.84 7.75999C38.84 8.58842 39.5116 9.25999 40.34 9.25999Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M38.17 8.6C38.7554 8.6 39.23 8.12542 39.23 7.54C39.23 6.95457 38.7554 6.48 38.17 6.48C37.5846 6.48 37.11 6.95457 37.11 7.54C37.11 8.12542 37.5846 8.6 38.17 8.6Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M44.83 14.22C45.907 14.22 46.78 13.347 46.78 12.27C46.78 11.1931 45.907 10.32 44.83 10.32C43.7531 10.32 42.88 11.1931 42.88 12.27C42.88 13.347 43.7531 14.22 44.83 14.22Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M44.37 9.97999C45.0438 9.97999 45.59 9.43378 45.59 8.75999C45.59 8.08621 45.0438 7.53999 44.37 7.53999C43.6962 7.53999 43.15 8.08621 43.15 8.75999C43.15 9.43378 43.6962 9.97999 44.37 9.97999Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M44.73 17.64C45.3044 17.64 45.77 17.1744 45.77 16.6C45.77 16.0256 45.3044 15.56 44.73 15.56C44.1556 15.56 43.69 16.0256 43.69 16.6C43.69 17.1744 44.1556 17.64 44.73 17.64Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M44.98 11.42C45.5765 11.42 46.06 10.9365 46.06 10.34C46.06 9.74353 45.5765 9.25999 44.98 9.25999C44.3835 9.25999 43.9 9.74353 43.9 10.34C43.9 10.9365 44.3835 11.42 44.98 11.42Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M36.62 10.97C37.2993 10.97 37.85 10.4193 37.85 9.73999C37.85 9.06068 37.2993 8.50999 36.62 8.50999C35.9407 8.50999 35.39 9.06068 35.39 9.73999C35.39 10.4193 35.9407 10.97 36.62 10.97Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M21.43 40.89C16 39.68 18.57 46.37 24.8 42.8L21.43 40.89Z",
    fill: "#5E534F",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M44.37 32.84C46.78 38.71 46.55 39.84 46.31 40.74C46.07 41.64 39.75 49.49 39.75 49.49L42.86 51.49C42.86 51.49 52.36 44.89 52.36 39.95",
    fill: "#252525"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M44.37 32.84C46.78 38.71 46.55 39.84 46.31 40.74C46.07 41.64 39.75 49.49 39.75 49.49L42.86 51.49C42.86 51.49 52.36 44.89 52.36 39.95",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M31.06 22.89C31.1213 27.0781 30.7425 31.261 29.93 35.37L21.43 40.89L24.8 42.8C27.4093 42.0321 29.9249 40.9756 32.3 39.65",
    fill: "#252525"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M31.06 22.89C31.1213 27.0781 30.7425 31.261 29.93 35.37L21.43 40.89L24.8 42.8C27.4093 42.0321 29.9249 40.9756 32.3 39.65",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M32.34 26.29C32.1796 29.4866 32.572 32.6869 33.5 35.75C33.8869 37.0531 33.791 38.4519 33.23 39.69",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstudiante2);
export default __webpack_public_path__ + "static/media/Estudiante2.1fb01330eec517c11e38b6fc0504aebc.svg";
export { ForwardRef as ReactComponent };